(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["arc-grind-dial"] && !Shopify.designMode) return;
  try {
    
(function () {
  var MINV = 1, MAXV = 16, STEP = 0.5, DEGPER = 18;
  function snap(v) { return Math.max(MINV, Math.min(MAXV, Math.round(v / STEP) * STEP)); }
  function fmt(v) { return (v % 1 === 0) ? String(v) : v.toFixed(1); }
  function grindInfo(v) {
    if (v < 2)    return { cat: "TURKISH", brew: "Super fine" };
    if (v < 4)    return { cat: "Espresso", brew: "Fine · pressurised" };
    if (v < 5)    return { cat: "Moka", brew: "Fine–medium" };
    if (v < 8.5)  return { cat: "Pour Over · V60", brew: "Medium" };
    if (v < 11.5) return { cat: "Drip · Chemex", brew: "Medium–coarse" };
    if (v < 14.5) return { cat: "French Press", brew: "Coarse" };
    return { cat: "Cold Brew", brew: "Extra coarse" };
  }
  function drawKnob(ctx, W, H, cur, accent) {
    accent = accent || "#B5673C";
    ctx.clearRect(0, 0, W, H);
    var cx = W * 0.5, cy = H * 0.6, R = Math.min(H * 0.38, W * 0.44);
    var rot = -cur * DEGPER * Math.PI / 180;
    var kg = ctx.createRadialGradient(cx - R*0.4, cy - R*0.45, R*0.1, cx, cy, R*1.18);
    kg.addColorStop(0, "#35322e"); kg.addColorStop(0.55, "#1d1b18"); kg.addColorStop(1, "#090807");
    ctx.beginPath(); ctx.arc(cx, cy, R, 0, Math.PI*2); ctx.fillStyle = kg; ctx.fill();
    ctx.lineWidth = 3; ctx.strokeStyle = "rgba(0,0,0,0.6)"; ctx.beginPath(); ctx.arc(cx, cy, R-2, 0, Math.PI*2); ctx.stroke();
    ctx.lineWidth = 1.5; ctx.strokeStyle = "rgba(255,250,242,0.07)"; ctx.beginPath(); ctx.arc(cx, cy, R-5, 0, Math.PI*2); ctx.stroke();
    var Rk = R * 0.9, teeth = 72, t;
    for (t = 0; t < teeth; t++) {
      var r = (t / teeth) * Math.PI * 2 + rot, co = Math.cos(r), si = Math.sin(r);
      ctx.strokeStyle = "rgba(255,250,242,0.13)"; ctx.lineWidth = 1.6;
      ctx.beginPath(); ctx.moveTo(cx + co*Rk, cy + si*Rk); ctx.lineTo(cx + co*(Rk-12), cy + si*(Rk-12)); ctx.stroke();
      var r2 = r + (Math.PI / teeth), co2 = Math.cos(r2), si2 = Math.sin(r2);
      ctx.strokeStyle = "rgba(0,0,0,0.6)"; ctx.lineWidth = 1.6;
      ctx.beginPath(); ctx.moveTo(cx + co2*Rk, cy + si2*Rk); ctx.lineTo(cx + co2*(Rk-12), cy + si2*(Rk-12)); ctx.stroke();
    }
    var Rf = R * 0.74;
    ctx.beginPath(); ctx.arc(cx, cy, Rf, 0, Math.PI*2); ctx.fillStyle = "#080807"; ctx.fill();
    ctx.lineWidth = 5; ctx.strokeStyle = "rgba(0,0,0,0.55)"; ctx.beginPath(); ctx.arc(cx, cy, Rf+2.5, 0, Math.PI*2); ctx.stroke();
    ctx.lineWidth = 1; ctx.strokeStyle = "rgba(255,250,242,0.05)"; ctx.beginPath(); ctx.arc(cx, cy, Rf-1, 0, Math.PI*2); ctx.stroke();
    var Rtick = R + 6, Rtxt = R + 34;
    ctx.textAlign = "center"; ctx.textBaseline = "middle";
    for (var n = cur - 8; n <= cur + 8; n += 0.5) {
      if (n < MINV || n > MAXV) continue;
      var ang = (-90 + (n - cur) * DEGPER) * Math.PI / 180;
      var dx = Math.cos(ang), dy = Math.sin(ang);
      var dist = Math.abs(n - cur);
      var fade = Math.max(0, 1 - Math.pow(dist / 7.5, 1.7));
      var isInt = (n % 1 === 0);
      var tlen = isInt ? 14 : 8;
      ctx.strokeStyle = "rgba(244,241,233," + ((isInt ? 0.85 : 0.45) * fade) + ")";
      ctx.lineWidth = isInt ? 2.2 : 1.4;
      ctx.beginPath();
      ctx.moveTo(cx + dx*Rtick, cy + dy*Rtick);
      ctx.lineTo(cx + dx*(Rtick + tlen), cy + dy*(Rtick + tlen));
      ctx.stroke();
      if (isInt) {
        var curMark = Math.abs(n - cur) < 0.001;
        var fs = Math.round((curMark ? 33 : 23) * (0.74 + 0.26 * fade));
        ctx.font = "600 " + fs + "px Poppins, sans-serif";
        ctx.fillStyle = curMark ? "rgba(244,241,233,1)" : "rgba(244,241,233," + (0.9 * fade) + ")";
        ctx.fillText(String(n), cx + dx*Rtxt, cy + dy*Rtxt);
      }
    }
    var px = cx, py = cy - (Rtxt + 26);
    ctx.fillStyle = accent;
    ctx.beginPath(); ctx.moveTo(px, py + 17); ctx.lineTo(px - 11, py); ctx.lineTo(px + 11, py); ctx.closePath(); ctx.fill();
    ctx.strokeStyle = accent; ctx.lineWidth = 3;
    ctx.beginPath(); ctx.moveTo(px, py); ctx.lineTo(px, py - 12); ctx.stroke();
  }
  function initDial(root) {
    if (!root || root.__arcInit) return;
    root.__arcInit = true;
    var cv = root.querySelector(".arcd-canvas");
    var numEl = root.querySelector(".arcd-num");
    var catEl = root.querySelector(".arcd-rocat");
    var slider = root.querySelector(".arcd-range");
    var midEl = root.querySelector(".arcd-rangemid");
    var cards = root.querySelectorAll(".arcd-card");
    if (!cv) return;
    var accent = (getComputedStyle(root).getPropertyValue("--arcd-accent") || "#B5673C").trim() || "#B5673C";
    var val = snap(parseFloat(root.getAttribute("data-default") || "7"));
    function render() {
      var dpr = Math.min(window.devicePixelRatio || 1, 2.5);
      var cssW = cv.clientWidth, cssH = cv.clientHeight;
      if (!cssW || !cssH) return;
      if (cv.width !== Math.round(cssW * dpr)) { cv.width = Math.round(cssW * dpr); cv.height = Math.round(cssH * dpr); }
      var ctx = cv.getContext("2d");
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      drawKnob(ctx, cssW, cssH, val, accent);
    }
    function update() {
      var info = grindInfo(val);
      if (numEl) numEl.textContent = fmt(val);
      if (catEl) catEl.textContent = info.cat;
      if (midEl) midEl.textContent = info.brew;
      if (slider) { slider.value = val; slider.style.setProperty("--p", ((val - MINV) / (MAXV - MINV) * 100) + "%"); }
      cv.setAttribute("aria-valuenow", val);
      for (var i = 0; i < cards.length; i++) {
        cards[i].classList.toggle("active", snap(parseFloat(cards[i].getAttribute("data-v"))) === val);
      }
      render();
    }
    function setVal(v) { var s = snap(v); val = s; update(); }
    var dragging = false, lastA = 0, acc = 0;
    function angleAt(x, y) { var r = cv.getBoundingClientRect(); return Math.atan2(y - (r.top + r.height/2), x - (r.left + r.width/2)) * 180 / Math.PI; }
    /* hit area = the inner black disc only (same geometry as drawKnob's Rf) */
    function knobHit(x, y) {
      var r = cv.getBoundingClientRect();
      var R = Math.min(r.height * 0.38, r.width * 0.44), Rf = R * 0.74;
      var dx = x - (r.left + r.width * 0.5), dy = y - (r.top + r.height * 0.6);
      return (dx * dx + dy * dy) <= Rf * Rf;
    }
    function down(e) {
      var t = e.touches ? e.touches[0] : e;
      if (!knobHit(t.clientX, t.clientY)) return;
      dragging = true; acc = val; lastA = angleAt(t.clientX, t.clientY);
      cv.classList.add("arcd-drag");
      if (e.cancelable) e.preventDefault();
    }
    function move(e) {
      if (!dragging) return;
      var t = e.touches ? e.touches[0] : e;
      var a = angleAt(t.clientX, t.clientY);
      var dd = a - lastA; if (dd > 180) dd -= 360; if (dd < -180) dd += 360;
      lastA = a;
      acc = Math.max(MINV, Math.min(MAXV, acc + dd / DEGPER));
      setVal(acc);
      if (e.cancelable) e.preventDefault();
    }
    function up() { dragging = false; cv.classList.remove("arcd-drag"); }
    cv.addEventListener("mousedown", down); cv.addEventListener("touchstart", down, { passive: false });
    cv.addEventListener("mousemove", function (e) { if (!dragging) cv.classList.toggle("arcd-over", knobHit(e.clientX, e.clientY)); });
    cv.addEventListener("mouseleave", function () { cv.classList.remove("arcd-over"); });
    window.addEventListener("mousemove", move); window.addEventListener("touchmove", move, { passive: false });
    window.addEventListener("mouseup", up); window.addEventListener("touchend", up);
    cv.addEventListener("keydown", function (e) {
      if (e.key === "ArrowUp" || e.key === "ArrowRight") { setVal(val + STEP); e.preventDefault(); }
      if (e.key === "ArrowDown" || e.key === "ArrowLeft") { setVal(val - STEP); e.preventDefault(); }
    });
    if (slider) slider.addEventListener("input", function () { setVal(parseFloat(slider.value)); });
    for (var c = 0; c < cards.length; c++) {
      (function (card) { card.addEventListener("click", function () { setVal(parseFloat(card.getAttribute("data-v"))); }); })(cards[c]);
    }
    window.addEventListener("resize", render);
    update();
    setTimeout(render, 80);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(render);
  }
  function initAll(scope) {
    var list = (scope || document).querySelectorAll(".arcd");
    for (var i = 0; i < list.length; i++) initDial(list[i]);
  }
  if (document.readyState !== "loading") initAll();
  else document.addEventListener("DOMContentLoaded", function () { initAll(); });
  document.addEventListener("shopify:section:load", function (e) { initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["full-edge-showcase"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('full-edge-showcase')) {
    customElements.define('full-edge-showcase', class extends HTMLElement {
      connectedCallback() {
        this.mediaTarget = this.querySelector('[data-fes-media]');
        this.mediaQuery = window.matchMedia('(max-width: 749px)');
        this.handleViewport = () => this.mountMedia();
        this.mediaQuery.addEventListener('change', this.handleViewport);
        this.mountMedia();

        if (!('IntersectionObserver' in window)) {
          this.classList.add('is-visible');
          return;
        }
        this.observer = new IntersectionObserver(([entry]) => {
          if (entry.isIntersecting) {
            this.classList.add('is-visible');
            this.observer.disconnect();
          }
        }, { rootMargin: '8% 0px', threshold: .08 });
        this.observer.observe(this);
      }

      mountMedia() {
        const mode = this.mediaQuery.matches ? 'mobile' : 'desktop';
        if (mode === this.mediaMode || !this.mediaTarget) return;
        const template = this.querySelector(`[data-fes-${mode}]`);
        if (!template) return;
        this.mediaTarget.querySelectorAll('video').forEach((video) => video.pause());
        this.mediaTarget.replaceChildren(template.content.cloneNode(true));
        this.mediaMode = mode;
        const video = this.mediaTarget.querySelector('video[autoplay]');
        if (video) video.play().catch(() => {});
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.mediaQuery && this.handleViewport) this.mediaQuery.removeEventListener('change', this.handleViewport);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reveal-image-showcase"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('reveal-image-showcase')) {
    customElements.define('reveal-image-showcase', class extends HTMLElement {
      connectedCallback() {
        if (this.cleanup || this.done || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        const stage = this.querySelector('.ris__stage');
        if (!stage || !('IntersectionObserver' in window)) return;
        const motion = matchMedia('(prefers-reduced-motion: reduce)');
        let frame = 0;
        let active = false;
        const finish = () => {
          this.style.removeProperty('--ris-inset');
          this.style.removeProperty('--ris-opacity');
          this.style.removeProperty('--ris-y');
          this.done = true;
          this.cleanup();
        };
        const update = () => {
          frame = 0;
          const height = document.documentElement.clientHeight;
          const end = innerWidth < 768 ? .16 : .08;
          const progress = Math.max(0, Math.min(1, (height * .82 - stage.getBoundingClientRect().top) / (height * (.82 - end))));
          if (motion.matches) return finish();
          const eased = progress * progress * (3 - 2 * progress);
          this.style.setProperty('--ris-inset', `${(1 - eased) * 36}%`);
          this.style.setProperty('--ris-opacity', Math.max(0, (progress - .3) / .7));
          this.style.setProperty('--ris-y', `${(1 - eased) * 18}px`);
        };
        const queue = () => { if (!frame) frame = requestAnimationFrame(update); };
        const activate = () => { active = true; addEventListener('scroll', queue, { passive: true }); queue(); };
        const deactivate = () => { active = false; removeEventListener('scroll', queue); };
        const observer = new IntersectionObserver(([entry]) => {
          if (entry.isIntersecting) { if (!active) activate(); }
          else deactivate();
        }, { rootMargin: '10% 0px' });
        this.cleanup = () => {
          observer.disconnect();
          deactivate();
          removeEventListener('resize', queue);
          motion.removeEventListener('change', finish);
          this.removeEventListener('focusin', finish);
          cancelAnimationFrame(frame);
          this.cleanup = null;
        };
        motion.addEventListener('change', finish);
        this.addEventListener('focusin', finish);
        addEventListener('resize', queue, { passive: true });
        observer.observe(this);
        update();
      }
      disconnectedCallback() { if (this.cleanup) this.cleanup(); }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
